<template>
  <v-card>
    <v-card-title class="py-3 px-4 border-bottom">
      <span class="gray--text text--darken-3 font-weight-regular">
        {{ isEditMode ? "Rolun redaktəsi" : "Yeni rol" }}
      </span>
    </v-card-title>
    <v-card-text>
      <v-form
        id="createRoleForm"
        ref="form"
        v-model="formValidation"
        lazy-validation
        @submit.prevent="handleFormSubmit"
      >
        <v-row>
          <v-col cols="12">
            <span class="ml-2">Rol statikdir?</span>
          </v-col>
          <v-col cols="12">
            <v-radio-group
              :disabled="isEditMode && selectedRole.isStatic ? true : false"
              class="my-2 pt-0"
              v-model="formData.isStatic"
              row
              hide-details
            >
              <v-radio class="ml-2" label="Hə" :value="true"></v-radio>
              <v-radio class="ml-2" label="Yox" :value="false"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-text-field
              type="text"
              label="Adı"
              filled
              dense
              v-model="formData.roleName"
              :rules="formRules.roleName"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              type="text"
              label="Fərqləndirici ad"
              filled
              dense
              v-model="formData.roleKey"
              :rules="formRules.roleKey"
              :disabled="isEditMode && selectedRole.isStatic ? true : false"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              type="text"
              label="Təsviri"
              filled
              dense
              auto-grow
              rows="1"
              v-model="formData.description"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="py-3 px-4 d-flex justify-end border-top">
      <v-btn color="gray lighten-3" depressed @click="toggleDialog">
        Bağla
      </v-btn>
      <v-btn
        :loading="isSubmittingForm"
        type="submit"
        form="createRoleForm"
        color="success"
        depressed
      >
        {{ isEditMode ? "Yadda saxla" : "Yarat" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    toggleDialog: {
      type: Function,
      required: true,
    },
    isSubmittingForm: {
      type: Boolean,
      required: true,
    },
    selectedRole: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      formValidation: false,
      formData: {
        roleName: "",
        roleKey: "",
        isStatic: false,
        description: "",
      },
      formRules: {
        roleName: [(v) => !!v || "İstifadəçi rolunun adını daxil edin"],
        roleKey: [
          (v) =>
            !this.formData.isStatic || !!v || "Fərqləndirici adı daxil edin",
        ],
        description: [(v) => !!v || "Təsviri daxil edin"],
      },
    };
  },
  computed: {
    isEditMode() {
      return (
        this.selectedRole && this.selectedRole.id && this.selectedRole.id > 0
      );
    },
  },
  watch: {
    selectedRole: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.formData = { ...newVal };
        } else {
          this.resetFormData();
        }
      },
    },
  },
  methods: {
    handleFormSubmit() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) {
        this.$emit("formSubmit", this.formData);
      }
    },
    resetFormData() {
      this.formData = {
        roleName: "",
        roleKey: "",
        isStatic: false,
        description: "",
      };
      this.$refs.form && this.$refs.form.resetValidation();
    },
  },
};
</script>
